package com.kanati.shared.district

import kotlinx.serialization.Serializable

const val DEFAULT_DISTRICT_TIMEZONE = "America/Denver"
const val DEFAULT_DISTRICT_TAX_RATE_BPS = 0

@Serializable
data class CreateDistrictRequest(
    val name: String,
    val city: String,
    val county: String,
    val state: USState,
    val timezone: String = DEFAULT_DISTRICT_TIMEZONE,
    val defaultTaxRateBps: Int = DEFAULT_DISTRICT_TAX_RATE_BPS,
)

@Serializable
data class District(
    val id: String,
    val name: String,
    val city: String,
    val county: String,
    val state: USState,
    val timezone: String,
    val defaultTaxRateBps: Int,
    val createdAt: String,
)

@Serializable
enum class USState {
    AK,
    AL,
    AR,
    AZ,
    CA,
    CO,
    CT,
    DE,
    FL,
    GA,
    HI,
    IA,
    ID,
    IL,
    IN,
    KS,
    KY,
    LA,
    MA,
    MD,
    ME,
    MI,
    MN,
    MO,
    MS,
    MT,
    NC,
    ND,
    NE,
    NH,
    NJ,
    NM,
    NV,
    NY,
    OH,
    OK,
    OR,
    PA,
    RI,
    SC,
    SD,
    TN,
    TX,
    UT,
    VA,
    VT,
    WA,
    WI,
    WV,
    WY,
}
